import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

import CloseIcon from "assets/icons/close.svg?react";
import taskService from "api/taskService";
import { useState, useMemo, useContext, useRef } from "react";
import { ITask } from "dto/ITask";
import moment from "moment";

import BinIcon from "assets/icons/bin.svg?react";
import UnCompleteIcon from "assets/icons/unhandled.svg?react";
import CompleteTask from "assets/icons/done.svg?react";
import Loading from "components/Loading";
import Button from "components/Button";
import ModalsManagerContext from "contexts/ModalsManager";
import { useOnClickOutside } from "hooks/useClickOutside";

const ChatActionBox = ({
  task,
  refetch,
  handleDeleteAction,
}: {
  task: ITask;
  refetch: () => void;
  handleDeleteAction?: () => void;
}) => {
  const [show, setShow] = useState(false);
  const { mutate: completeTask } = taskService.useComplete();
  const { mutate: UnCompleteTask } = taskService.useUncomplete();
  const { mutate: deleteTask } = taskService.useDeleteTask();
  let format = "DD.MM.YYYY | HH:mm";

  if (task.AllDay) {
    format = "DD.MM.YYYY";
  }

  const handleClickComplete = () => {
    if (task.CompleteDate) {
      UnCompleteTask(
        {
          Id: task.Id,
        },
        {
          onSuccess: () => refetch(),
        }
      );
      return;
    }
    completeTask(
      {
        Id: task.Id,
      },
      {
        onSuccess: () => refetch(),
      }
    );
  };

  const handleDelete = () => {
    deleteTask(
      {
        Id: task.Id,
        MoveToTrash: false,
      },
      {
        onSuccess: () => {
          refetch();
          handleDeleteAction?.();
        },
      }
    );
  };

  return (
    <div className={styles.box}>
      <div className={styles.color}></div>
      <div className={styles.info}>
        <div className={styles.title}>{task.Title} </div>
        <div className={styles.note}>{task.Note} </div>
      </div>
    </div>
  );

  return (
    <div
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      className={styles.box}
    >
      {show && (
        <div className={styles.options}>
          {task.CompleteDate ? (
            <UnCompleteIcon
              onClick={(e) => {
                handleClickComplete();
                e.stopPropagation();
              }}
            />
          ) : (
            <CompleteTask
              onClick={(e) => {
                handleClickComplete();
                e.stopPropagation();
              }}
            />
          )}
          <BinIcon
            onClick={(e) => {
              handleDelete();
              e.stopPropagation();
            }}
          />
        </div>
      )}

      <div className={styles.dates}>
        {task.FromDate ? moment(task.FromDate).format(format).toString() : ""}{" "}
        {task.FromDate && "-"}
        {task.ToDate && moment(task.ToDate).format(format).toString()}
      </div>

      <div className={styles.title}>{task.Note} </div>
    </div>
  );
};

const ChatActionsList: FC<Props> = ({
  onDelete,
  toggle,
  changeView, // eslint-disable-line @typescript-eslint/no-unused-vars
  pack,
  x, // eslint-disable-line @typescript-eslint/no-unused-vars
  y, // eslint-disable-line @typescript-eslint/no-unused-vars
}) => {
  const { t } = useTranslation();
  const { data, isLoading, refetch } = taskService.useGetTask({
    OwnerId: pack.Id,
    OwnerKind: pack.Kind,
  });

  //@ts-ignore
  const tasks: ITask[] = useMemo(() => (data?.data as ITask[]) ?? [], [data]);

  const { modals, setModals } = useContext(ModalsManagerContext);

  const ref = useRef();

  useOnClickOutside(ref, () => {
    toggle(false);
  });

  return (
    <div ref={ref} className={styles.wrapper}>
      <div className={styles.header}>
        {t("actions.title")}
        <CloseIcon
          className={styles.closeIcon}
          onClick={(e) => {
            toggle(false);
            e.stopPropagation();
          }}
        />
      </div>
      {isLoading ? (
        <div className={styles.loadingWrapper}>
          <Loading />
        </div>
      ) : (
        <div className={styles.list}>
          {tasks.map((task: ITask) => (
            <ChatActionBox
              handleDeleteAction={onDelete}
              refetch={refetch}
              task={task}
            />
          ))}
        </div>
      )}

      <div className={styles.buttonWrapper}>
        <Button
          text={t("actions.new")}
          onClick={() => {
            setModals({ ...modals, createTask: true, hide: false });
          }}
        />
      </div>
    </div>
  );
};

export default ChatActionsList;
